<template>

  <div id="app" class="dtl">
    <nav class="topHeader">
      <div class="container">
        <div class="row text-end">
          <div class="col">
            <a class="btn btn-outline-light btn-sm btn-round"
            data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
            aria-controls="offcanvasExample">Stats</a>
          </div>
        </div>
      </div>
    </nav>


    <div class="offcanvas offcanvas-end p-3" :class="sidebarActive ? 'show' : ''" id="offcanvasExample" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" aria-labelledby="offcanvasScrollingLabel">
      <!-- <div class="offcanvas-header">
        <div class="offcanvas-title text-center" id="offcanvasScrollingLabel">
          <img src="@/assets/img/dtl.png" class="dtl-logo" alt="dtl">
        </div>
      </div>
      <hr />-->
      <div class="offcanvas-body p-4">
        <div class="row websiteScanned">
          <div class="col-3">
            <h1>{{ dtl.websites }}</h1>
          </div>
          <div class="col">
            <!-- <strong>Websites scanned during DTL 2023</strong> -->
            <strong>Websites scanned</strong>
          </div>
        </div>
        <div class="vulns">
          <div class="row">
            <div class="col-3">
              <h1 class="crit">{{ dtl.critical }}</h1>
            </div>
            <div class="col">
              <strong>Very High Vulnerabilities Found</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h1 class="high">{{ dtl.high }}</h1>
            </div>
            <div class="col">
              <strong>High Vulnerabilities Found</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h1 class="medium">{{ dtl.medium }}</h1>
            </div>
            <div class="col">
              <strong>Medium Vulnerabilities Found</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h1 class="low">{{ dtl.low }}</h1>
            </div>
            <div class="col">
              <strong>Low Vulnerabilities Found</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h1 class="insig">{{ dtl.insignificant }}</h1>
            </div>
            <div class="col">
              <strong>Insignificant Vulnerabilities Found</strong>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="container">
      <div class="row">
        <div class="col text-center">
          <img src="@/assets/img/logo.png" class="pentester-logo" alt="pentester">

          <div class="question-line title">How <div class="blueHighlight">safe</div> is your website from Hackers?</div>

          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">


          <div class="home text-center">
            <div class="mt-3 scancompleted" v-if="scanCompleted">
              <div class="text-center">
                <div>We have <strong>IDENTIFIED</strong> the following vulnerabilities across <strong class="target">{{ url }}</strong>.</div>

                <div class="heatTable mt-3">
                  <table class="table pb-0 mb-0">
                    <thead>
                      <tr>
                        <th class="insig">Insignificant</th>
                        <th class="low">Low</th>
                        <th class="medium">Medium</th>
                        <th class="high">High</th>
                        <th class="very_high">Very High</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ result.insignificant }}</td>
                        <td>{{ result.low }}</td>
                        <td>{{ result.medium }}</td>
                        <td>{{ result.high }}</td>
                        <td>{{ result.critical }}</td>
                        <td>{{ result.total }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="clientInfo mt-4 text-center">
                <div class="mb-3">
                  <button class="btn btn-outline-info reruntest" v-on:click="newScan()">Start a New Test</button>
                </div>
                <div>
                  <div>To receive a copy of these results please provide your <strong>Email Address.</strong></div>
                  <div class="send-email mt-3">
                    <form v-on:submit="sendToEmail">
                      <div class="row mb-4">
                          <div class="col-md-9">
                            <input type="text" v-on:focus="isEmailValid = true" class="form-control text-center" :class="isEmailValid ? '' : 'is-invalid'" placeholder="Enter Email Address" v-model="user_info.email">
                          </div>
                          <div class="col">
                            <button class="btn btn-info btn-sendEmail" type="submit">Send</button>
                          </div>
                      </div>
                    </form>
                    <div class="legal">
                      <i><p>This scan provides no promises that the automated penetration testing finds all, or even substantially all vulnerabilities, misconfigurations, security concerns, information, evidence, causes of the incident or security best practices. The person/s requesting the scan takes full Ownership and liability for any "harm" or "damage" resulting from the scan activity.</p><p class="mt-3 mb-4">By providing your email address, you are giving Vertex Cyber Security permission to contact you via email for the purpose of providing product and marketing related updates. Double opt in will be required to confirm your subscription to Vertex Cyber Security email communications.</p></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-search" v-else>
              <p>Enter your website below to run an automated test.</p>
              <form v-on:submit="run">
                <input type="text" name="" class="form-control" v-on:focus="isUrlValid = true" :class="isUrlValid ? '' : 'is-invalid'" placeholder="Enter URL" v-model="url">
                <div class="runtest-btn mt-3" >
                  <button class="btn btn-info text-white btn-sm me-2" type="submit">Run Test</button>
                </div>
              </form>
           </div>
          </div>


        </div>
      </div>
    </div>

    <footer :class="scanCompleted ? '' : 'stickTobuttom'">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center mb-3">
            <div>
              <img src="@/assets/img/vertex.png" class="vtx-logo" alt="vertex cyber security">
            </div>
          </div>
          <div class="col-12 mt-4">
            <div class="contact">
              <ul>
                <li>
                  <a href="mailto:info@vertexcybersecurity.com.au">
                    <i class="fas fa-envelope"></i> info@vertexcybersecurity.com.au
                  </a>
                </li>
                <li>
                  <a href="tel:1300 2 CYBER (29237)">
                    <i class="fas fa-phone-alt"></i> 1300 2 CYBER (29237)
                  </a>
                </li>
                <li>
                  <a href="https://www.vertexcybersecurity.com.au">
                    <i class="fas fa-globe"></i> www.vertexcybersecurity.com.au
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  import '@/assets/css/dtl.css'
  import axios from 'axios'
  export default {
    data() {
      return {
        sidebarActive: true,
        url: '',
        isUrlValid: true,
        isEmailValid: true,
        scanCompleted: false,
        result: {
          insignificant: 0,
          low: 0,
          medium: 0,
          high: 0,
          critical: 0,
          total: 0,
          result_id: 0
        },
        user_info: {
          domain: '',
          email: '',
          result_id: 0,
          status: 1
        },
        dtl: {
          websites: 0,
          critical: 0,
          high: 0,
          insignificant: 0,
          low: 0,
          medium: 0,
        },
      }
    },
    mounted() {
      this.init();
      var me = this;

      setInterval(function(){
        me.init();
      }, 60000);

      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },

    methods: {
      init() {
        const uninterceptedAxiosInstance = axios.create();
        let me = this;

        uninterceptedAxiosInstance({
          method: 'get',
          url: this.$server + 'quickscan'
        })
        .then(res => {
          if (res.data.success) {
            me.dtl = res.data.data;
          }
        });
      },

      handleResize() {
        const width = window.innerWidth;
        if (width < 776) {
          this.sidebarActive = false;
        }
      },

      newScan() {
        this.scanCompleted = false;
        this.url = '';
        this.isUrlValid = true;
        this.isEmailValid = true;
        this.init()
      },

      run(e) {
        e.preventDefault();

        if (this.url == "") {
          this.isUrlValid = false;
          this.$swal({
              title: "The URL field is required.",
              icon: "error"
            });
          return
        }

        document.getElementById("loading").style.display = "block";
        const uninterceptedAxiosInstance = axios.create();
        let me = this;
        uninterceptedAxiosInstance({
          method: 'post',
          url: this.$server + 'quickscan',
          data: {
            url: this.url
          }
        })
        .then(res => {
          document.getElementById("loading").style.display = "none";
          res = res.data;
          if (res.success) {
            me.result = res.data;
            me.scanCompleted = true;
            me.result.result_id = res.result_id;
            me.user_info.result_id = res.result_id;
            me.user_info.domain = me.url;

            me.result.total = parseInt(res.data.insignificant) + parseInt(res.data.low) + parseInt(res.data.medium) + parseInt(res.data.high) + parseInt(res.data.critical);
            this.$swal({
              title: "The scanning process has been completed successfully.",
            });
          } else {
            this.$swal({
              title: res.msg,
              icon: "error"
            });
            this.isUrlValid = false;
          }
        });
      },

      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },

      sendToEmail(e) {
        e.preventDefault();
        if (this.user_info.email == "") {
          this.isEmailValid = false;
          this.$swal({
              title: "The Email field is required.",
              icon: "error"
            });
          return
        }

        if (!this.isValidEmail(this.user_info.email)) {
          this.isEmailValid = false;
          this.$swal({
              title: "Email address is not valid.",
              icon: "error"
            });
          return
        }

        document.getElementById("loading").style.display = "block";
        const uninterceptedAxiosInstance = axios.create();
        let me = this;

        uninterceptedAxiosInstance({
          method: 'put',
          url: this.$server + 'quickscan',
          data: this.user_info
        })
        .then(res => {
          document.getElementById("loading").style.display = "none";
          if (res.data.success) {
            this.$swal({
              title: res.data.message,
            });
          }
          me.scanCompleted = false;
          me.user_info = {
            domain: '',
            email: '',
            result_id: 0,
            status: 1
          };

          me.url = "";
          me.isUrlValid = true;
          me.isEmailValid = true;

          me.init();
        });
      }
    }
  }
</script>